<template>
  <el-container class="combo-info-container">
    <el-aside>
      <img :src="avatar" class="avatar" />
      <div class="title">Hi，{{ comboInfo.school_name }}</div>
      <el-form class="aside-form" v-if="comboInfo.is_mobile == 2">
        <el-form-item label="产品：" class="title"> 电话机器人 </el-form-item>
        <el-form-item label="版本："> {{ typeInfo.type }}档 </el-form-item>
        <el-form-item label="有效时间：" class="time">
          {{ comboInfo.mobile_expire_time }}
        </el-form-item>
        <el-form-item label="400电话：">
          {{ comboInfo.service_phone }}
        </el-form-item>
      </el-form>
      <el-form class="aside-form" v-if="comboInfo.is_text == 2">
        <el-form-item label="产品：" class="title"> 文字机器人 </el-form-item>
        <el-form-item label="版本："> 标准版 </el-form-item>
        <el-form-item label="有效时间：" class="time">
          {{ comboInfo.text_expire_time }}
        </el-form-item>
      </el-form>
    </el-aside>
    <div class="info-content">
      <div class="residual" v-if="comboInfo.almost_expired_time <= 10">
        <i class="el-icon-warning-outline"></i>
        电话机器人{{
          comboInfo.almost_expired_time <= 0
            ? '已过期'
            : `还有${comboInfo.almost_expired_time}天过期`
        }}
        ，请联系客服续费或升级服务！
      </div>
      <div class="combo-info">
        <div class="progress-container">
          <el-progress
            type="circle"
            :percentage="comboInfo.pre_time"
            :stroke-width="20"
            :width="114"
            :color="colors"
          ></el-progress>
          <div class="rt">
            <div>剩余通话时长</div>
            <div>{{ comboInfo.surp }}</div>
          </div>
        </div>
        <div class="progress-container">
          <el-progress
            type="circle"
            :percentage="comboInfo.pre_sms"
            :stroke-width="20"
            :width="114"
            :color="colors"
          ></el-progress>
          <div class="rt">
            <div>剩余短信条数</div>
            <div>{{ comboInfo.surp_sms }}条</div>
          </div>
        </div>
      </div>
      <div class="combo-detail">
        <div class="content-form">
          <div class="label">
            <div></div>
            购买套餐详情（套餐档位：{{ typeInfo.type }}档）
          </div>
          <div class="content">
            <div><i></i>线路并发数：{{ typeInfo.concurrent }}路</div>
            <div><i></i>总通话{{ typeInfo.call }}万分钟</div>
            <div><i></i>可发送挂断短信通知{{ typeInfo.message }}万条</div>
          </div>
        </div>
        <div class="content-form">
          <div class="label">
            <div></div>
            其他套餐
          </div>
          <div class="other-content">
            <div class="other-combo">
              <div class="title">套餐档位：A档</div>
              <div>
                <el-checkbox :value="true" fill="#23bda1" />线路并发数：30路
              </div>
              <div>
                <el-checkbox
                  :value="true"
                  fill="#23bda1"
                />A类400号码（号码可选）
              </div>
              <div>
                <el-checkbox :value="true" fill="#23bda1" />总通话4万分钟
              </div>
              <div>
                <el-checkbox
                  :value="true"
                  fill="#23bda1"
                />可发送挂断短信通知10万条
              </div>
            </div>
            <div class="other-combo">
              <div class="title">套餐档位：B档</div>
              <div>
                <el-checkbox :value="true" fill="#23bda1" />线路并发数：20路
              </div>
              <div>
                <el-checkbox
                  :value="true"
                  fill="#23bda1"
                />B类400号码（号码可选）
              </div>
              <div>
                <el-checkbox :value="true" fill="#23bda1" />总通话3万分钟
              </div>
              <div>
                <el-checkbox
                  :value="true"
                  fill="#23bda1"
                />可发送挂断短信通知8万条
              </div>
            </div>
            <div class="other-combo">
              <div class="title">套餐档位：C档</div>
              <div>
                <el-checkbox :value="true" fill="#23bda1" />线路并发数：10路
              </div>
              <div>
                <el-checkbox
                  :value="true"
                  fill="#23bda1"
                />C类400号码（号码可选）
              </div>
              <div>
                <el-checkbox :value="true" fill="#23bda1" />总通话2万分钟
              </div>
              <div>
                <el-checkbox
                  :value="true"
                  fill="#23bda1"
                />可发送挂断短信通知6万条
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
  import { getComboInfo } from '@/api/dataView'
  export default {
    data() {
      return {
        avatar: window.sessionStorage.getItem('avatar'),
        colors: [
          { color: '#f56c6c', percentage: 20 },
          { color: '#e6a23c', percentage: 40 },
          { color: '#409EFF', percentage: 100 },
        ],
        comboInfo: {
          call_time: '',
          is_mobile: 2,
          school_name: '',
          is_text: 2,
          mobile_expire_time: '',
          text_expire_time: '',
          service_phone: '',
          surp: '',
          package_type: 3,
          pre_sms: 0,
          pre_time: 0,
          surp: '',
          surp_sms: '',
          almost_expired_time: 100,
        },
        typeInfo: {
          type: '/',
          concurrent: '/',
          call: '/',
          message: '/',
        },
      }
    },
    mounted() {
      this.getComboInfo()
    },
    methods: {
      async getComboInfo() {
        const res = await getComboInfo()
        if (res.data) {
          this.comboInfo = res.data
          this.setTypeInfo(res.data.package_type)
        }
      },
      setTypeInfo(type) {
        switch (type) {
          case 1: {
            this.typeInfo = {
              type: 'A',
              concurrent: '30',
              call: '4',
              message: '10',
            }
            break
          }
          case 2: {
            this.typeInfo = {
              type: 'B',
              concurrent: '20',
              call: '3',
              message: '8',
            }
            break
          }
          case 3: {
            this.typeInfo = {
              type: 'C',
              concurrent: '10',
              call: '2',
              message: '6',
            }
            break
          }
        }
      },
    },
  }
</script>

<style lang="scss">
  .combo-info-container {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    // height: 100%;
    color: #333;
    font-size: 16px;
    background-color: #f5f5f5;
    box-sizing: border-box;
    .el-aside {
      width: 360px;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      .avatar {
        margin: 60px 20px 32px 0;
        width: 150px;
        height: 150px;
        border-radius: 50%;
      }
      .title {
        height: 46px;
        line-height: 46px;
        font-size: 30px;
      }
      .aside-form {
        margin-top: 40px;
        width: 100%;
        .el-form-item__label {
          flex-shrink: 0;
        }
        .el-form-item__label,
        .el-form-item__content {
          color: #333;
          font-size: 16px;
        }
        .el-form-item {
          display: flex;
          align-items: center;
          padding: 0 10px;
          height: 30px;
        }
        .title {
          color: #333;
          border-radius: 6px;
          height: 48px;
          background: #efefef;
          border-radius: 5px;
        }
        .time {
          .el-form-item__content {
            font-size: 14px;
          }
        }
      }
    }
    .info-content {
      display: flex;
      flex-direction: column;
      min-width: 875px;
      width: 100%;
      padding-left: 20px;
      box-sizing: border-box;
      .residual {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 20px;
        min-width: 400px;
        font-size: 18px;
        height: 60px;
        color: #f44f00;
        background: rgba(254, 172, 50, 0.2);
        border: 1px solid rgba(244, 79, 0, 0.31);
        border-radius: 10px;
        .el-icon-warning-outline {
          margin-right: 10px;
          font-size: 23px;
        }
      }
      .combo-info {
        display: flex;
        justify-content: space-between;

        .progress-container {
          display: flex;
          align-items: center;
          padding: 20px;
          margin-bottom: 20px;
          width: 49%;
          min-width: 240px;
          font-size: 14px;
          height: 200px;
          background: #ffffff;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          box-sizing: border-box;
          .rt {
            margin-left: 20px;
            div:first-child {
              margin-bottom: 20px;
            }
            div:last-child {
              color: #f6a518;
              font-weight: 700;
            }
          }
        }
      }
      .combo-detail {
        padding: 40px 0 0 36px;
        height: 100%;
        background-color: #fff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        box-sizing: border-box;
      }

      .content-form {
        .label {
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #333333;
          height: 30px;
          line-height: 30px;
          div {
            margin-right: 16px;
            width: 4px;
            height: 16px;
            background-color: #22bca1;
          }
        }
        .content {
          margin-left: 40px;
          display: flex;
          color: #666;
          div {
            display: flex;
            align-items: center;
            i {
              margin-right: 12px;
              width: 8px;
              height: 8px;
              background: linear-gradient(90deg, #39da9b, #20b9a2);
              border-radius: 50%;
            }
          }
          div:nth-child(2) {
            margin: 0 200px;
          }
        }

        .other-content {
          //   width: 100%;
          padding-left: 20px;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          //   height: 220px;
          background: #ffffff;
        }
        .other-combo {
          padding: 20px;
          width: 33%;
          height: 280px;
          box-sizing: border-box;
          box-shadow: 0px 6px 14px 0px #e2ecff;
          opacity: 0.8;
          border-radius: 0px 0px 20px 20px;
          div {
            padding: 25px 0 0 20px;
            font-size: 14px;
          }
          .el-checkbox {
            margin-right: 14px;
          }
          .title {
            padding-top: 0;
            padding-left: 33px;
            height: 60px;
            line-height: 60px;
            font-size: 20px;
            font-weight: 700;
            color: #ffffff;
            background: linear-gradient(90deg, #39da9b, #20b9a2);
            border-radius: 20px 20px 0px 0px;
          }
        }
        .other-combo:nth-child(2) {
          .title {
            background: linear-gradient(90deg, #5887d4, #65cbe4);
          }
        }
        .other-combo:last-child {
          .title {
            background: linear-gradient(90deg, #ffa769, #ea5360);
          }
        }
      }
      .content-form:first-child {
        margin-bottom: 60px;
      }
    }
  }
</style>
